import { Injectable, inject } from '@angular/core';
import { CanMatch } from '@angular/router';
import { ENUM_ClientUserViewType } from '@api-new/common';
import { Store } from '@ngrx/store';
import { selectClientUser, selectClientUserIsLoading } from '@shared/store/client-user/client-user.selectors';
import { Observable } from 'rxjs';
import { filter, map, mergeMap, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class LandlordGuard implements CanMatch {
  private readonly store = inject(Store);

  canMatch(): Observable<boolean> {
    return this.store.select(selectClientUserIsLoading).pipe(
      filter((isLoading) => !isLoading),
      take(1),
      map(() => {
        return this.store
          .select(selectClientUser)
          .pipe(map((clientUser) => clientUser.clientUserViewType === ENUM_ClientUserViewType.CLIENT_USER_VIEW_TYPE_LANDLORD));
      }),
      mergeMap((val) => val),
    );
  }
}
